import { getEventById } from 'api/event'
import { useEffect, useState } from 'react'
import { EventDetails, EventType } from 'types/Event'

export const useEventDetails = (events: EventType[] | undefined) => {
    const [eventDetails, setEventDetails] = useState<Record<string, EventDetails>>({})
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<Error | null>(null)

    useEffect(() => {
        const fetchEventDetails = async () => {
            if (!events) return

            setLoading(true)
            try {
                const eventDetailPromises = events.map(async (event) => {
                    const details = await getEventById(event.event_id)
                    return { eventId: event.event_id, details }
                })

                const results = await Promise.all(eventDetailPromises)

                const detailsById = results.reduce(
                    (acc, { eventId, details }) => {
                        acc[eventId] = details
                        return acc
                    },
                    {} as Record<string, EventDetails>,
                )

                setEventDetails(detailsById)
            } catch (err) {
                setError(err as Error)
            } finally {
                setLoading(false)
            }
        }

        fetchEventDetails()
    }, [events])

    return { eventDetails, isLoading: loading, error }
}
